/**
 * Componente para mostrar tarjeta de progreso
 */

import React from "react";

interface ProgresoCardProps {
  titulo: string;
  valor: string | number;
  subtitulo?: string;
  icono?: React.ReactNode;
  color?: "blue" | "green" | "yellow" | "purple";
}

export const ProgresoCard: React.FC<ProgresoCardProps> = ({
  titulo,
  valor,
  subtitulo,
  icono,
  color = "blue",
}) => {
  const colorClasses = {
    blue: {
      iconBg: "bg-gradient-to-br from-blue-500 to-blue-600",
      iconText: "text-white",
      border: "border-blue-200",
      title: "text-blue-600",
    },
    green: {
      iconBg: "bg-gradient-to-br from-green-500 to-green-600",
      iconText: "text-white",
      border: "border-green-200",
      title: "text-green-600",
    },
    yellow: {
      iconBg: "bg-gradient-to-br from-yellow-500 to-yellow-600",
      iconText: "text-white",
      border: "border-yellow-200",
      title: "text-yellow-600",
    },
    purple: {
      iconBg: "bg-gradient-to-br from-purple-500 to-purple-600",
      iconText: "text-white",
      border: "border-purple-200",
      title: "text-purple-600",
    },
  };

  const colors = colorClasses[color];

  return (
    <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-6 border border-gray-100 hover:border-gray-200">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className={`text-sm font-semibold ${colors.title} mb-2`}>
            {titulo}
          </p>
          <p className="text-4xl font-bold text-gray-900 mb-1">{valor}</p>
          {subtitulo && (
            <p className="mt-1 text-xs text-gray-500 font-medium">
              {subtitulo}
            </p>
          )}
        </div>
        {icono && (
          <div
            className={`flex-shrink-0 rounded-xl p-4 ${colors.iconBg} ${colors.iconText} shadow-md`}
          >
            {icono}
          </div>
        )}
      </div>
    </div>
  );
};
